import { AlertTriangle, CheckCircle2, Circle, Clock3, XCircle } from "lucide-react";
import type { ReadinessStatus } from "@mola/contracts";
import { useI18n } from "../i18n";

const map = {
  READY: { key: "ready", Icon: CheckCircle2 },
  REVIEW: { key: "review", Icon: Clock3 },
  MISSING: { key: "missing", Icon: AlertTriangle },
  NOT_STARTED: { key: "notStarted", Icon: Circle },
  IN_PROGRESS: { key: "inProgress", Icon: Clock3 },
  CANCELLED: { key: "cancelled", Icon: XCircle }
} as const;

export function StatusBadge({ status }: { status: ReadinessStatus }) {
  const { t } = useI18n();
  const { key, Icon } = map[status];
  return <span className={`status-badge status-${status.toLowerCase().replace("_", "-")}`}><Icon size={15} aria-hidden="true" /><span>{t(key)}</span></span>;
}

export function StatusSummary({ status, count }: { status: ReadinessStatus; count: number }) {
  const { t } = useI18n();
  const { key, Icon } = map[status];
  return <div className={`status-summary status-${status.toLowerCase().replace("_", "-")}`}><Icon aria-hidden="true" /><div><span>{t(key)}</span><strong>{count}</strong></div></div>;
}
